import React from 'react'
import { withRouter } from 'react-router-dom';
import ThreeBlockDivision from './../../../home/Drive/Cards/ThreeBlockDivision'
class CounterCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    componentWillMount() {
        this.setState({ loading: true });
        setTimeout(
            function () {
                this.setState({ loading: false });
            }
                .bind(this),
            2500
        );
    }


    render() {
        let showLoader = this.state.loading || this.props.loadingMyOrganization || this.props.loadingOrganization;
        return (
            <div>
                 <div className="count-content" style={{ border: "1px solid #d4d4d5", borderBottom: "none", margin: "0 0 10px 0", borderRadius: "4px" }}>
                    <ThreeBlockDivision
                        type="community"
                        label1Name="Teams"
                        label1Count={showLoader ? 0 : this.props.organizationCountData ? this.props.organizationCountData.totalSubOrganization : 0}
                        label2Name="Users"
                        label2Count={showLoader ? 0 : this.props.allOrgUsers ? this.props.allOrgUsers : 0}
                        label3Name="Invitations"
                        label3Count={showLoader ? 0 : this.props.organizationCountData ? this.props.organizationCountData.invitationSend : 0}
                        history={this.props.history}
                        isLoadingData={this.props.isLoadingData}
                        selectedOrganisation={this.props.selectedOrganisation}
                    />
                </div>
            </div>
        )
    }
}


export default withRouter(CounterCard);